module.exports = __webpack_public_path__ + "static/media/collapse.74ccf2e2.svg";